const Component = {
    "图片 url 不存在": "URL изображения не существует",
    "暂不支持下载此类型图片": "Этот тип изображения пока не поддерживается для загрузки",
};
  
export default Component;
  